var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"base-view"},[_c('h1',{staticClass:"title is-3"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"columns is-centered"},[_c('div',{staticClass:"column is-7"},[_vm._t("left-content")],2),_c('div',{staticClass:"column is-5"},[_vm._t("right-content")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }